import ErrorBoundary from '@components/ErrorBoundary';
import Codebook from '@components/interview/details/Codebook';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { Suspense } from 'react';

export default function InterviewCodebook() {
  return (
    <PageContainer title={'Interview | Codebook'}>
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary>
          <Codebook />
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
